<template>
  <nav :class="`site-footer__item site-footer__${navigationClass}`">
    <p
      v-if="header"
      class="site-footer__list-header"
      v-text="header"
    />
    <ul class="site-footer__list">
      <li
        v-for="(tier1) of navigationMenu"
        :key="tier1.handle"
        class="site-footer__list-item"
      >
        <!-- AccessiBe -->
        <btn
          v-if="tier1.title === $variable('accessibe.accessibeSettingsKey')"
          data-acsb="trigger"
          modifiers="text"
          type="button"
          :show-text-icon="false"
          :label="tier1.title"
          @click="handleGtm"
        />

        <btn
          v-if="tier1.handle === 'live-chat'"
          modifiers="text"
          type="button"
          :label="tier1.title"
          :show-text-icon="showIcon"
          onclick="zE('messenger', 'open');"
          @click="handleGtm"
        />

        <btn
          v-else-if="tier1.title === 'Returns'"
          modifiers="text"
          type="button"
          :show-text-icon="false"
          :label="tier1.title"
          @click="ingridReturnsClick"
        />

        <btn
          v-else
          custom-element="a"
          modifiers="text"
          type="button"
          :label="tier1.title"
          :url="tier1.url"
          :show-text-icon="showIcon"
          @click="handleGtm"
        />

        <span
          v-if="tier1.tag1"
          :key="tier1.tag1"
          class="site-footer__item-tag--first site-footer__item-tag"
          v-text="tier1.tag1"
        />

        <span
          v-if="tier1.tag2"
          :key="tier1.tag2"
          class="site-footer__item-tag--second site-footer__item-tag"
          v-text="tier1.tag2"
        />
      </li>
    </ul>
  </nav>
</template>

<script>

/**
 * Vue: Link List
 * -----------------------------------------------------------------------------
 * Site footer component with accordion display of links.
 *
 * @param {String} navigationClass - Footer link list classname.
 * @param {String} navigationMenu - Footer menu item.
 * @param {String} header - Footer link list header text.
 * @param {Boolean} showIcon - show text button icon.
 *
 */
import Btn from '~global/btn/btn'

export default {
  name: 'LinkList',

  components: {
    Btn,
  },

  props: {
    navigationClass: {
      type: String,
      default: '',
    },
    navigationMenu: {
      type: Array,
      default: () => [],
      required: true,
    },
    header: {
      type: String,
      default: '',
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
  },

  emits: {
    'ingrid-returns-clicked': () => true,
  },

  data() {
    return {}
  },

  methods: {

    ingridReturnsClick() {
      cnvs.EventBus.emit('ingrid-returns-clicked')

    },

    handleGtm(event) {
      const dataLayer = window.dataLayer || []
      const target = event.currentTarget

      dataLayer.push({
        event: 'footer_click',
        footerClick: {
          click_url: target.href,
          click_text: target.innerText,
        },
      })
    },
  },
}

</script>
